// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__UnxYN","content":"LayoutSettings_content__nRPm_"};